const fallbackUuid = () => `srm-${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`;

export const createIdempotencyKey = prefix => {
  const uuid = typeof window !== "undefined" && window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : fallbackUuid();
  return `${String(prefix || "payments-v2").slice(0, 45)}:${uuid}`.slice(0, 100);
};

// A command draft owns one key. The key is cleared only after a definitive
// result, so a timeout/reconnect retry cannot create a second money action.
export function createCommandKeyStore(prefix) {
  let current = null;
  return {
    get() {
      if (!current) current = createIdempotencyKey(prefix);
      return current;
    },
    clear() { current = null; },
    peek() { return current; },
  };
}
